import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import { retrieveFromLocalStorage } from '../../../utils/util';

import {
  requestViewContract,
  requestAmendContract,
  requestUpdateContractStatus,
  requestCancelContract,
  requestRetrieveChatForDeal,
  requestCreateMessageForDeal,
} from '../../../api/contract/contract.actions';
import { requestDownloadDocument } from '../../../api/document/document.actions';
import { addMessageToChat } from '../../../slices/contract/contract.slice';

import Deal from '../../../components/screens/shop/deal/Deal';

const DealContainer = () => {
  const { contract, chats } = useSelector(({ contract }) => contract);
  const { profile } = useSelector(({ party }) => party);
  const { events } = useSelector(({ event }) => event);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { contractExternalReference, chat } = useParams();

  useEffect(() => {
    dispatch(
      requestViewContract({
        contractExternalReference,
        onSuccess: (contract) => {
          if (contract) {
            dispatch(requestRetrieveChatForDeal({ dealNumber: contract.dealNumber, showSpinner: true }));
          }
        },
      })
    );
  }, [dispatch, contractExternalReference]);

  useEffect(() => {
    if (!contract || !events || events.length === 0) return;

    for (const chat of chats) {
      const event = events.find((event) => event.domainObjectExternalReference === chat.externalReference);
      if (event) {
        dispatch(requestRetrieveChatForDeal({ dealNumber: contract.dealNumber, showSpinner: false }));
        break;
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, contract, events]);

  const amendContract = (contract) => {
    dispatch(requestAmendContract({ contract, onSuccess: () => navigate('/shop/deal-room') }));
  };

  const updateContractStatus = (dealNumber, status) => {
    dispatch(requestUpdateContractStatus({ dealNumber, status, onSuccess: () => navigate('/shop/deal-room') }));
  };

  const downloadDocument = (externalReference, name) => {
    dispatch(requestDownloadDocument({ externalReference, name }));
  };

  const cancelContract = (dealNumber) => {
    dispatch(requestCancelContract({ dealNumber, onSuccess: () => navigate(-1) }));
  };

  const messageSentOnSuccess = () => {
    dispatch(requestViewContract({ contractExternalReference }));
  };

  const sendMessage = (chatExternalReference, text, onSuccess) => {
    const personExternalReference = retrieveFromLocalStorage('personExternalReference');

    dispatch(
      requestCreateMessageForDeal({
        message: {
          message: text,
          chatExternalReference,
          personExternalReference,
        },
        onSuccess: () => {
          const dateToAdjust = new Date();
          const offset = dateToAdjust.getTimezoneOffset() * 60000;
          const dateTime = new Date(dateToAdjust.getTime() - offset);

          const message = {
            organisationExternalReference: profile.organisationExternalReference,
            organisationName: profile.companyName,
            message: text,
            dateTime,
            personExternalReference,
          };

          dispatch(addMessageToChat({ chatExternalReference, message }));
          onSuccess();
        },
      })
    );
  };

  return (
    <Deal
      contract={contract}
      chats={chats}
      profile={profile}
      amendContract={amendContract}
      updateContractStatus={updateContractStatus}
      downloadDocument={downloadDocument}
      cancelContract={cancelContract}
      sendMessage={sendMessage}
      messageSentOnSuccess={messageSentOnSuccess}
      openChat={chat && chat === 'open'}
    />
  );
};

export default DealContainer;
